import classNames from 'classnames';

type Props = {
  className?: string;
  color: string;
  label: string;
  percentage: number;
  value?: number;
  valueColor?: string;
};

const MetricCard: React.FC<Props> = ({
  className,
  color,
  label,
  percentage,
  value,
  valueColor,
}) => (
  <div className={classNames('relative rounded-xl bg-[#f5f4ed] p-3', className)}>
    <div className="mb-2 flex items-start justify-between gap-2">
      <p className="min-w-0 break-words text-sm text-gray-600">{label}</p>
      <div
        className="shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold text-white"
        style={{ backgroundColor: color }}
      >
        {percentage}%
      </div>
    </div>

    <p className="text-xl font-bold" style={{ color: valueColor }}>
      {value?.toFixed(2) ?? '-'}
    </p>

    <div className="mt-2 h-1 w-full rounded bg-gray-200">
      <div
        className="h-1 rounded"
        style={{
          backgroundColor: color,
          width: `${(value ?? 0) * 33}%`,
        }}
      />
    </div>
  </div>
);

export default MetricCard;
